import styled from 'styled-components';
import { TooltipStyled } from '../TooltipStyled';
import { rem } from 'polished';

export const TooltipStyledAP = styled(TooltipStyled)`
    .tooltip-box {
        width: fit-content !important;
        padding: ${rem('5px')} ${rem('14px')} !important;
        margin-top: ${rem('8px')} !important;
        &-basket {
            font-size: ${rem('10px')} !important;
            margin-top: 0 !important;
            padding: ${rem('5px')} ${rem('14px')} !important;
            max-width: ${rem('160px')} !important;
        }
    }
`;
